import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

type Props = {
    name: string;
    label?: string;
    required?: boolean;
    error?: FieldError;
    register: UseFormRegisterReturn;
    help?: string;
};

export const InputText = ({
                              name,
                              label,
                              required = false,
                              error,
                              register,
                              help,
                          }: Props) => {
    return (
        <div className="input_text">
            <label htmlFor={name}>
                <span>{label}</span>
                {required && (
                    <strong>
                        <abbr title="required">*</abbr>
                    </strong>
                )}
                <input
                    type="text"
                    id={name}
                    {...register}
                    required={required}
                    name={name}
                />
            </label>
            {/* The same slot carries help text and validation errors, so
                without a modifier a "Company name is required." rendered in
                exactly the muted grey used for hints — the field went red, the
                sentence explaining why did not. */}
            <small className={`block_help${error?.message ? ' block_help_error' : ''}`}>
                {error?.message || help}
            </small>
        </div>
    );
};
